export const isPro = () => {
  return localStorage.getItem("license") === "PRO";
};

export const getLicense = () => {
  return localStorage.getItem("license") || "BASIC";
};
